import { render } from "./AddressBox.vue?vue&type=template&id=431899ba&scoped=true"
import script from "./AddressBox.vue?vue&type=script&lang=js"
export * from "./AddressBox.vue?vue&type=script&lang=js"

import "./AddressBox.vue?vue&type=style&index=0&id=431899ba&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\matress-main\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-431899ba"]])

export default __exports__